export const topBarHeight = 64
export const sideNavWidth = 260
export const navbarHeight = 60
export const sidenavCompactWidth = 80
export const containedLayoutWidth = 1200

// export const goServerUrl = 'http://localhost:3001'
export const goServerUrl = 'https://product.trustyindonesia.com:3001'
